import { createFileRoute } from '@tanstack/react-router';
import CandidateTagsTemplate from '@/features/agent/candidate_tags/components/CandidateTagsTemplate';

export const Route = createFileRoute('/agent/candidate_tags')({
  component: CandidateTagsTemplate,
});
